(function ($) {
  var elementorHookRegistered = false;
  var arrowIcon = '<svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="44" cy="44" r="44" fill="#FCBC12"/><path d="M25 43.6667H62.3333M62.3333 43.6667L43.6667 25M62.3333 43.6667L43.6667 62.3333" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initSlider($slider) {
    if (!$slider.length || !$.fn.slick || $slider.hasClass('slick-initialized')) {
      return;
    }

    $slider.slick({
      infinite: true,
      centerMode: true,
      centerPadding: '200px',
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Precedent">' + arrowIcon + '</button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Suivant">' + arrowIcon + '</button>',
      responsive: [
        {
          breakpoint: 1536,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerPadding: '80px'
          }
        }
      ]
    });
  }

  function initFormationsSlider($scope) {
    $scope.find('[data-formations-slider]').each(function () {
      initSlider($(this));
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;
    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/formations-slider.default',
      initFormationsSlider
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();

    $('[data-formations-slider]').each(function () {
      initSlider($(this));
    });
  });
})(jQuery);
